import styled from "styled-components";
import { MapControlContainer, TextContainer } from "../../styled";

export const ZoomLevelText = styled(TextContainer)`
  cursor: pointer;
`;

export const ZoomLevelContainer = styled(MapControlContainer)`
  width: 2.5rem;
  height: 15.25rem !important;
  padding: 0;
  justify-content: center;
  flex-direction: column;
  flex-wrap: nowrap;
`;

export const SliderContainer = styled.div`
  height: 100%;
  min-height: 1px;
`;
